import { forwardRef } from 'react';
import { ItemLinkProps } from '../../types';
import { Basic } from './basic';

export const Link = forwardRef<HTMLAnchorElement, ItemLinkProps>(
  function Component(props, forwardedRef) {
    return <Basic {...props} Component="a" rootRef={forwardedRef} />;
  }
);
